import $ from 'jquery';

class Menu {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$page = $('.page');
        this.$openButton = $('.js-menu-open');
        this.$closeButton = $('.js-menu-close');
        this.$menu = $('.js-menu');
        this.$menuLogo = $('.js-menu-logo');
        this.$body = $('body');
        this.menuOpen = false;
        this.addClickHandlers();
    }

    addClickHandlers() {
        this.$openButton.on('click', e => {
            e.preventDefault();
            this.toggleMenu();
        });

        this.$closeButton.on('click', e => {
            e.preventDefault();
            this.toggleMenu();
        });
    }

    toggleMenu() {
        this.menuOpen ? this.closeMenu() : this.openMenu();
    }

    openMenu() {
        this.menuOpen = true;
        this.$page.addClass('inactive');
        this.$menu.addClass('active');
        setTimeout(() => this.$menuLogo.focus(), 600);
        this.$body.on('keydown', e => this.handleKeydown(e));
    }

    closeMenu() {
        this.menuOpen = false;
        this.$page.removeClass('inactive');
        this.$menu.removeClass('active');
        this.$openButton.blur();
        this.$body.off('keydown');
        $(window).scrollTop(0);
    }

    handleKeydown(e) {
        const $focused = $(e.target);

        if (e.which === 27) {
            // escape - close menu
            e.preventDefault();
            this.closeMenu();
        } else if (e.which === 9 && e.shiftKey) {
            // tab + shift - cycle backwards within nav links
            if (
                this.$menu
                    .find('a')
                    .first()
                    .is($focused)
            ) {
                e.preventDefault();
                this.$closeButton.focus();
            }

            if (this.$closeButton.is($focused)) {
                e.preventDefault();
                this.$menu
                    .find('a')
                    .last()
                    .focus();
            }
        } else if (e.which === 9) {
            // tab - cycle within nav links
            if (
                this.$menu
                    .find('a')
                    .last()
                    .is($focused)
            ) {
                e.preventDefault();
                this.$closeButton.focus();
            }

            if (this.$closeButton.is($focused)) {
                e.preventDefault();
                this.$menu
                    .find('a')
                    .first()
                    .focus();
            }
        }
    }

    static init() {
        if ($('.js-menu').length > 0) {
            new Menu();
        }
    }
}

export default Menu;
